<div class="lg:text-lg font-semibold text-black">Kontaktkanäle</div>
<span class="text-xs lg:text-sm text-lightText">Über welche Kanäle dürfen wir Sie kontaktieren?</span>

<div class="grid grid-cols-2 lg:gap-x-8 gap-y-4 w-full mt-2 text-lightText">
  @for (contactChannel of customerConsentResponse?.contactChannelList; track contactChannel.eventName) {
    <div class="flex gap-2 lg:gap-4 items-center">
      <div class="flex gap-1">
        <app-checkbox-icon
          [imageClass]="getContactChannelIcon(contactChannel, 'unchecked')"
          class="cursor-pointer"
          (click)="change(contactChannel, ConsentStatus.WITHDRAWN)"
        />
        <app-checkbox-icon
          [imageClass]="getContactChannelIcon(contactChannel, 'checked')"
          class="cursor-pointer"
          (click)="change(contactChannel, ConsentStatus.CONFIRMED)"
        />
      </div>
      <label>{{ contactChannel.displayName }}</label>
    </div>
  }
</div>
